import { Close, Search } from "@mui/icons-material";
import {
  CircularProgress,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";
import { FC } from "react";
import { TopToolbar as RaTopToolbar } from "react-admin";
import { NewUserButton } from "./new-user-button.component";
import { useAccess, useDebouncedListSearch } from "@/hooks";
import { ResourceName } from "@/utils";

const TopToolbar: FC = () => {
  const { canCreate } = useAccess();

  const isUsersFetching = false;

  const [searchQuery, setSearchQuery] = useDebouncedListSearch();

  return (
    <RaTopToolbar
      sx={{
        width: "100%",
        marginTop: 1,
        paddingRight: 0,
      }}
    >
      <Stack direction={"row"} spacing={1}>
        <TextField
          size="small"
          variant="outlined"
          placeholder="Search by user"
          sx={{ width: "220px" }}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          slotProps={{ htmlInput: { maxLength: 50 } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {!!isUsersFetching && <CircularProgress size={16} />}
                {!isUsersFetching && !!searchQuery && (
                  <Close
                    sx={{ cursor: "pointer" }}
                    onClick={() => setSearchQuery("")}
                  />
                )}
              </InputAdornment>
            ),
          }}
        />

        {canCreate(ResourceName.ADMIN_USERS) && <NewUserButton />}
      </Stack>
    </RaTopToolbar>
  );
};

export { TopToolbar };
